/**
 * Translations for the GuidedFlow component (digital waiter).
 * Each key maps to {cat, es, en, fr}. Use `tr(language, key, vars?)` to get
 * the translated string, with optional {var} interpolation.
 */

const STRINGS = {
  // ── Welcome ──
  welcome_title_default: {
    cat: 'Aix\u00f2 no \u00e9s nom\u00e9s\nprendre alguna cosa.',
    es: 'Esto no es solo\ntomar algo.',
    en: 'This is more than\njust a drink.',
    fr: 'Ce n\u2019est pas juste\nun verre.',
  },
  welcome_subtitle_default: {
    cat: 'Ets a Besal\u00fa. Aqu\u00ed tot t\u00e9 origen, hist\u00f2ria i sabor. Deixa\u2019t guiar.',
    es: 'Est\u00e1s en Besal\u00fa. Aqu\u00ed todo tiene origen, historia y sabor. Deja que te guiemos.',
    en: 'You\u2019re in Besal\u00fa. Everything here has origin, history and flavour. Let us guide you.',
    fr: 'Vous \u00eates \u00e0 Besal\u00fa. Tout ici a une origine, une histoire et une saveur. Laissez-vous guider.',
  },
  start: { cat: 'Comen\u00e7ar', es: 'Empezar', en: 'Start', fr: 'Commencer' },
  back: { cat: 'Enrere', es: 'Atr\u00e1s', en: 'Back', fr: 'Retour' },

  // ── Party size ──
  party_title: { cat: 'Quants sou?', es: '\u00bfCu\u00e1ntos sois?', en: 'How many are you?', fr: 'Combien \u00eates-vous\u00a0?' },
  party_subtitle: {
    cat: 'Aix\u00ed ho preparem tot per a vosaltres.',
    es: 'As\u00ed preparamos todo para vosotros.',
    en: 'So we can prepare everything for you.',
    fr: 'Nous pr\u00e9parerons tout pour vous.',
  },
  or_more: { cat: 'o m\u00e9s', es: 'o m\u00e1s', en: 'or more', fr: 'ou plus' },

  // ── Drink type ──
  drink_type_greet_solo: { cat: 'Perfecte.', es: 'Perfecto.', en: 'Perfect.', fr: 'Parfait.' },
  drink_type_greet_group: {
    cat: 'Sou {n}, genial.',
    es: 'Sois {n}, genial.',
    en: '{n} of you, great.',
    fr: 'Vous \u00eates {n}, super.',
  },
  drink_type_question: {
    cat: 'Qu\u00e8 us ve de gust per beure?',
    es: '\u00bfQu\u00e9 os apetece para beber?',
    en: 'What would you like to drink?',
    fr: 'Que souhaitez-vous boire\u00a0?',
  },
  with_alcohol: { cat: 'Amb alcohol', es: 'Con alcohol', en: 'With alcohol', fr: 'Avec alcool' },
  no_alcohol: { cat: 'Sense alcohol', es: 'Sin alcohol', en: 'No alcohol', fr: 'Sans alcool' },

  // ── Drink category ──
  drink_cat_alcohol_title: {
    cat: 'La nostra bodega us espera.',
    es: 'Nuestra bodega os espera.',
    en: 'Our cellar awaits.',
    fr: 'Notre cave vous attend.',
  },
  drink_cat_no_alcohol_title: {
    cat: 'Frescor i sabor.',
    es: 'Frescura y sabor.',
    en: 'Freshness and flavour.',
    fr: 'Fra\u00eecheur et saveur.',
  },
  drink_cat_subtitle: { cat: 'Trieu la categoria.', es: 'Elegid la categor\u00eda.', en: 'Pick a category.', fr: 'Choisissez une cat\u00e9gorie.' },
  products_count: { cat: '{n} productes', es: '{n} productos', en: '{n} products', fr: '{n} produits' },

  // ── Recommendations (drink) ──
  rec_house: {
    cat: 'Recomanaci\u00f3 de la casa',
    es: 'Recomendaci\u00f3n de la casa',
    en: 'House recommendation',
    fr: 'Suggestion de la maison',
  },
  rec_premium_multi: {
    cat: 'Mira, de {cat}, tenim quelcom especial.',
    es: 'Mira, de {cat}, tenemos algo especial.',
    en: 'For {cat}, we have something special.',
    fr: 'Pour {cat}, nous avons quelque chose de sp\u00e9cial.',
  },
  rec_premium_single: {
    cat: 'Us recomanem {name}.',
    es: 'Os recomiendo {name}.',
    en: 'I recommend {name}.',
    fr: 'Je vous recommande {name}.',
  },
  rec_bestseller_drink: {
    cat: 'El que m\u00e9s demanen de {cat}.',
    es: 'Lo que m\u00e1s piden de {cat}.',
    en: 'Most ordered in {cat}.',
    fr: 'Le plus demand\u00e9 en {cat}.',
  },
  rec_default_drink: {
    cat: 'De {cat}, us suggerim aix\u00f2.',
    es: 'De {cat}, os sugiero esto.',
    en: 'From {cat}, here\u2019s our pick.',
    fr: 'En {cat}, voici notre choix.',
  },
  rec_premium_sub: {
    cat: 'El nostre producte estrella.',
    es: 'Nuestro producto estrella.',
    en: 'Our flagship product.',
    fr: 'Notre produit phare.',
  },
  rec_bestseller_sub: {
    cat: 'El preferit dels nostres clients.',
    es: 'El favorito de nuestros clientes.',
    en: 'Our customers\u2019 favourite.',
    fr: 'Le favori de nos clients.',
  },
  badge_premium: { cat: 'Premium', es: 'Premium', en: 'Premium', fr: 'Premium' },
  badge_recommended: { cat: 'Recomanat', es: 'Recomendado', en: 'Recommended', fr: 'Recommand\u00e9' },
  badge_bestseller_default: {
    cat: 'El m\u00e9s dem.',
    es: 'Lo m\u00e1s pedido',
    en: 'Most ordered',
    fr: 'Le plus demand\u00e9',
  },
  see_all_drinks: {
    cat: 'Veure totes les {cat}',
    es: 'Ver todos los {cat}',
    en: 'See all {cat}',
    fr: 'Voir tout en {cat}',
  },

  // ── Drink select ──
  swipe_to_explore: {
    cat: 'Llisqueu amunt per explorar.',
    es: 'Deslizad arriba para explorar.',
    en: 'Swipe up to explore.',
    fr: 'Faites d\u00e9filer pour explorer.',
  },

  // ── Drink confirm ──
  your_drinks: { cat: 'Les vostres begudes', es: 'Vuestras bebidas', en: 'Your drinks', fr: 'Vos boissons' },
  drinks_done: {
    cat: 'Ja tinc les meves begudes',
    es: 'Ya tengo mis bebidas',
    en: "I'm done with drinks",
    fr: 'J\u2019ai mes boissons',
  },
  add_another_drink: {
    cat: 'Afegir una altra beguda',
    es: 'A\u00f1adir otra bebida',
    en: 'Add another drink',
    fr: 'Ajouter une autre boisson',
  },
  change_last: {
    cat: 'Canviar l\u2019\u00faltima',
    es: 'Cambiar la \u00faltima',
    en: 'Change the last one',
    fr: 'Changer le dernier',
  },

  // ── Food prompt ──
  food_prompt_title: {
    cat: 'Voleu menjar alguna cosa?',
    es: '\u00bfQuer\u00e9is comer algo?',
    en: 'Would you like to eat something?',
    fr: 'Voulez-vous manger quelque chose\u00a0?',
  },
  food_prompt_sub: {
    cat: 'Acompanyeu la beguda amb alguna cosa de la nostra cuina.',
    es: 'Acompa\u00f1ad la bebida con algo de nuestra cocina.',
    en: 'Pair your drink with something from our kitchen.',
    fr: 'Accompagnez votre boisson avec quelque chose de notre cuisine.',
  },
  food_yes: { cat: 'S\u00ed, mostreu-me', es: 'S\u00ed, veamos', en: "Yes, let's see", fr: 'Oui, montrez-moi' },
  food_no: { cat: 'Nom\u00e9s beure, gr\u00e0cies', es: 'Solo bebida, gracias', en: 'Just drinks, thanks', fr: 'Juste les boissons, merci' },
  prefer_food_first: {
    cat: 'Prefereixo veure primer el menjar',
    es: 'Prefiero ver primero la comida',
    en: "I'd rather see the food first",
    fr: 'Je pr\u00e9f\u00e8re voir d\u2019abord la nourriture',
  },
  prefer_drink_first: {
    cat: 'Prefereixo veure primer la beguda',
    es: 'Prefiero ver primero la bebida',
    en: "I'd rather see the drinks first",
    fr: 'Je pr\u00e9f\u00e8re voir d\u2019abord la boisson',
  },

  // ── Food cat ──
  food_cat_title: {
    cat: 'Qu\u00e8 us ve de gust?',
    es: '\u00bfQu\u00e9 os apetece?',
    en: 'What sounds good?',
    fr: 'Qu\u2019est-ce qui vous fait envie\u00a0?',
  },
  food_cat_sub: {
    cat: 'De la cuina al plat, amb tendresa.',
    es: 'De la cocina al plato, con cari\u00f1o.',
    en: 'From kitchen to plate, with care.',
    fr: 'De la cuisine \u00e0 l\u2019assiette, avec soin.',
  },

  // ── Food rec ──
  rec_premium_food: {
    cat: 'De {cat}, us recomanem aix\u00f2.',
    es: 'De {cat}, os recomiendo esto.',
    en: 'From {cat}, I recommend this.',
    fr: 'En {cat}, je vous recommande ceci.',
  },
  rec_bestseller_food: {
    cat: 'El m\u00e9s dem. de {cat}.',
    es: 'Lo m\u00e1s pedido de {cat}.',
    en: 'Most ordered from {cat}.',
    fr: 'Le plus demand\u00e9 en {cat}.',
  },
  rec_default_food: {
    cat: 'De {cat}, proveu aix\u00f2.',
    es: 'De {cat}, probad esto.',
    en: 'From {cat}, try this.',
    fr: 'En {cat}, essayez ceci.',
  },
  see_all_food: {
    cat: 'Veure tot a {cat}',
    es: 'Ver todo en {cat}',
    en: 'See all in {cat}',
    fr: 'Voir tout en {cat}',
  },
  see_all_food_btn: {
    cat: 'Veure tota la carta de menjar',
    es: 'Ver toda la comida',
    en: 'See all food',
    fr: 'Voir toute la nourriture',
  },

  // ── Food confirm ──
  your_food: { cat: 'El vostre menjar', es: 'Vuestra comida', en: 'Your food', fr: 'Votre nourriture' },
  food_done: {
    cat: 'Ja tinc el meu menjar',
    es: 'Ya tengo mi comida',
    en: "I'm done with food",
    fr: 'J\u2019ai mon plat',
  },
  add_more_food: {
    cat: 'Afegir alguna cosa m\u00e9s',
    es: 'A\u00f1adir algo m\u00e1s',
    en: 'Add something else',
    fr: 'Ajouter autre chose',
  },
  change_last_food: {
    cat: 'Canviar l\u2019\u00faltim',
    es: 'Cambiar lo \u00faltimo',
    en: 'Change the last one',
    fr: 'Changer le dernier',
  },

  // ── Summary ──
  your_order: { cat: 'La vostra comanda', es: 'Tu pedido', en: 'Your order', fr: 'Votre commande' },
  person_one: { cat: 'persona', es: 'persona', en: 'person', fr: 'personne' },
  person_many: { cat: 'persones', es: 'personas', en: 'people', fr: 'personnes' },
  table: { cat: 'Taula', es: 'Mesa', en: 'Table', fr: 'Table' },
  drinks_label: { cat: 'Begudes', es: 'Bebidas', en: 'Drinks', fr: 'Boissons' },
  food_label: { cat: 'Menjar', es: 'Comida', en: 'Food', fr: 'Nourriture' },
  total: { cat: 'Total', es: 'Total', en: 'Total', fr: 'Total' },
  confirm_order: { cat: 'Finalitzar i mostrar al cambrer', es: 'Finalizar y mostrar al camarero', en: 'Finish and show to the waiter', fr: 'Terminer et montrer au serveur' },
  add_more: { cat: 'Afegir m\u00e9s', es: 'A\u00f1adir m\u00e1s', en: 'Add more', fr: 'Ajouter plus' },
  add_more_title: {
    cat: 'Qu\u00e8 m\u00e9s us ve de gust?',
    es: '\u00bfQu\u00e9 m\u00e1s os apetece?',
    en: 'What else would you like?',
    fr: 'Quoi d\u2019autre vous fait envie\u00a0?',
  },
  add_more_drink: { cat: 'M\u00e9s beguda', es: 'M\u00e1s bebida', en: 'More drinks', fr: 'Plus de boissons' },
  add_more_food: { cat: 'M\u00e9s menjar', es: 'M\u00e1s comida', en: 'More food', fr: 'Plus de nourriture' },
  waiter_modal_title: { cat: 'Mostra-li aix\u00f2 al cambrer', es: 'Muestra esto al camarero', en: 'Show this to the waiter', fr: 'Montrez ceci au serveur' },
  waiter_modal_sub: {
    cat: 'El cambrer veur\u00e0 el text traduit al castell\u00e0 sota cada producte.',
    es: 'Tu camarero ver\u00e1 cada producto traducido al castellano para que no haya confusiones.',
    en: 'Your waiter will see each item translated into Spanish for clarity.',
    fr: 'Votre serveur verra chaque produit traduit en espagnol pour plus de clart\u00e9.',
  },
  waiter_modal_close: { cat: 'Tancar', es: 'Cerrar', en: 'Close', fr: 'Fermer' },
  order_registered: {
    cat: 'Comanda registrada (mode dev)',
    es: 'Pedido registrado (dev mode)',
    en: 'Order registered (dev mode)',
    fr: 'Commande enregistr\u00e9e (mode dev)',
  },

  // ── Product detail overlay ──
  customize_choice: {
    cat: 'Personalitza la teva tria',
    es: 'Personaliza tu elecci\u00f3n',
    en: 'Customize your choice',
    fr: 'Personnalisez votre choix',
  },
  options_label: { cat: 'Opcions', es: 'Opciones', en: 'Options', fr: 'Options' },
  extras_label: { cat: 'Extres', es: 'Extras', en: 'Extras', fr: 'Extras' },
  allergens_label: { cat: 'Al\u00b7l\u00e8rgens', es: 'Al\u00e9rgenos', en: 'Allergens', fr: 'Allerg\u00e8nes' },
  add_btn: { cat: 'Afegir', es: 'A\u00f1adir', en: 'Add', fr: 'Ajouter' },
  validation_required: {
    cat: 'Has de seleccionar una opci\u00f3 a cada grup.',
    es: 'Debes seleccionar una opci\u00f3n en cada grupo.',
    en: 'Please select one option per group.',
    fr: 'Veuillez s\u00e9lectionner une option par groupe.',
  },
  validation_bread: {
    cat: 'Has de triar un tipus de pa.',
    es: 'Debes elegir un tipo de pan.',
    en: 'Please choose a bread type.',
    fr: 'Veuillez choisir un type de pain.',
  },
  validation_wine: {
    cat: 'Has de seleccionar el tipus de vi.',
    es: 'Debes seleccionar el tipo de vino.',
    en: 'Please select the wine type.',
    fr: 'Veuillez s\u00e9lectionner le type de vin.',
  },

  // Group titles in product detail
  grp_tipo_pan: { cat: 'Tria el teu pa', es: 'Escoge tu pan', en: 'Choose your bread', fr: 'Choisissez votre pain' },
  grp_tipo_vino: { cat: 'Selecciona el tipus de vi', es: 'Selecciona el tipo de vino', en: 'Select wine type', fr: 'Choisissez votre vin' },
  grp_tipo_leche: { cat: 'Tipus de llet', es: 'Tipo de leche', en: 'Milk type', fr: 'Type de lait' },
  grp_tipo_bebida: { cat: 'Tria la teva beguda', es: 'Elige tu bebida', en: 'Choose your drink', fr: 'Choisissez votre boisson' },
  grp_tipo_bikini: { cat: 'Tria el teu bikini', es: 'Elige tu bikini', en: 'Choose your bikini', fr: 'Choisissez votre bikini' },
  grp_ensalada: { cat: 'Tria la teva amanida', es: 'Elige tu ensalada', en: 'Choose your salad', fr: 'Choisissez votre salade' },
  grp_principal: { cat: 'Tria el teu plat principal', es: 'Elige tu plato principal', en: 'Choose your main', fr: 'Choisissez votre plat' },
  grp_postre: { cat: 'Tria el teu postre', es: 'Elige tu postre', en: 'Choose your dessert', fr: 'Choisissez votre dessert' },

  // Error boundary
  oops_title: { cat: 'Un moment\u2026', es: 'Un momento\u2026', en: 'One moment\u2026', fr: 'Un instant\u2026' },
  oops_sub: {
    cat: 'Hem tingut un petit entrebanc. Toca per tornar a comen\u00e7ar.',
    es: 'Hemos tenido un peque\u00f1o tropiezo. Toca para volver a empezar.',
    en: "We hit a small snag. Tap to start over.",
    fr: 'Petit incident. Touchez pour recommencer.',
  },
  oops_retry: {
    cat: 'Tornar a comen\u00e7ar',
    es: 'Volver a empezar',
    en: 'Start over',
    fr: 'Recommencer',
  },
};

const FALLBACK = 'es';

export const tr = (lang, key, vars = {}) => {
  const entry = STRINGS[key];
  if (!entry) return key;
  let s = entry[lang] || entry[FALLBACK] || '';
  for (const [k, v] of Object.entries(vars)) {
    s = s.replace(new RegExp(`\\{${k}\\}`, 'g'), v);
  }
  return s;
};
